import React, { useEffect, useState, useRef, useCallback } from "react";
import PageLoader from "../../../shared/PageLoader";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import {
  callExcelHeaderToDbColumns,
  configUpload,
  getColumns,
  getInputModuleMappingDetails,
  resetConfigUploadDetails,
  resetEmployeeAttendanceUploadDetails,
  resetEmployeeLeaveAvailedUploadDetails,
  resetEmployeeLeaveCreditUploadDetails,
  resetEmployeeUploadDetails,
  resetEmployeeWageUploadDetails,
  resetExcelHeaderToDbColumnsDetails,
  resetGetColumnsDetails,
  resetGetConfigMappingDetails,
  resetDownloadFormat,
  getCompanyEmployerSubContractors,
} from "../../../../redux/features/performerClient.slice";
import { useGetUserCompanies } from "../../../../backend/query";
import { FULL_USER_COMPANIES_PAYLOAD } from "../../../../backend/license";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import cloudUpload from "../../../../assets/img/icon/cloudUpload.svg";
import { ERROR_MESSAGES, ESTABLISHMENT_TYPE } from "../../../../utils/constants";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import { Alert } from "react-bootstrap";
import {
  download,
  preventDefault,
} from "../../../../utils/common";
import Select, { components } from "react-select";
import PerformerBaseFilters from "../shared/PerformerBaseFilters";
import PerformerTable from "../shared/PerformerTable";
import PerformerDropdownIndicator from "../shared/PerformerDropdownIndicator";
import { hasUserAccess } from "../../../../backend/auth";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import { SAMPLE_FORMAT_S3_KEY_MAPPING } from "../../../../utils/registersQue.utils";
import { InputModuleService } from '../../../../backend/inputModule';
import { useAssociateCompanyLogo } from '../../../../contexts/AssociateCompanyContext';
import "../shared/performer-client.css";


const customStyles = {
  control: (base: any) => ({
    ...base,
    maxHeight: 150,
    overflow: "auto",
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

const CustomOption = (props: any) => (
  <div title={props.label}>
    <components.Option {...props} />
  </div>
);

// Synthetic "All" entry reinstated into the Associate Company list — selecting
// it shows the parent company's own branding instead of a specific AC's (see
// handleChangeAssociateCompany). PerformerBaseFilters sorts whatever list it's
// given alphabetically by name, so this can land anywhere in the dropdown
// rather than pinned to the top; that shared component is out of scope here.
const ALL_AC_OPTION = { id: "all", name: "All" };

const FieldMapping = () => {
  const dispatch = useAppDispatch();

  const { userCompanies, isFetching: isFetchingCompanies } = useGetUserCompanies(FULL_USER_COMPANIES_PAYLOAD, true);

  const companies = userCompanies || [];
  const { setAssociateCompanyBranding } = useAssociateCompanyLogo();

  const configUploadDetails = useAppSelector(
    (state) => state.performerClient.configUploadDetails,
  );
  const getColumnsDetails = useAppSelector(
    (state) => state.performerClient.getColumnsDetails,
  );
  const getDownloadFormat = useAppSelector(
    (state) => state.performerClient.downloadFormat,
  );
  const excelHeaderToDbColumnsDetails = useAppSelector(
    (state) => state.performerClient.excelHeaderToDbColumnsDetails,
  );
  const employeeUploadDetails = useAppSelector(
    (state) => state.performerClient.employeeUploadDetails,
  );
  const employeeAttendanceUploadDetails = useAppSelector(
    (state) => state.performerClient.employeeAttendanceUploadDetails,
  );
  const employeeLeaveCreditUploadDetails = useAppSelector(
    (state) => state.performerClient.employeeLeaveCreditUploadDetails,
  );
  const employeeLeaveAvailedUploadDetails = useAppSelector(
    (state) => state.performerClient.employeeLeaveAvailedUploadDetails,
  );
  const employeeWageUploadDetails = useAppSelector(
    (state) => state.performerClient.employeeWageUploadDetails,
  );
  const configMappingDetails = useAppSelector(
    (state) => state.performerClient.configMappingDetails,
  );

  const configMappingList =
    (configMappingDetails && configMappingDetails.data.items) || [];

  const configurationList =
    (configUploadDetails && configUploadDetails.data.items) || [];
  const columnsList = getColumnsDetails && getColumnsDetails.data.columns;

  const loading =
    configMappingDetails.status === "loading" ||
    employeeUploadDetails.status === "loading" ||
    employeeAttendanceUploadDetails.status === "loading" ||
    employeeLeaveCreditUploadDetails.status === "loading" ||
    employeeLeaveAvailedUploadDetails.status === "loading" ||
    employeeWageUploadDetails.status === "loading" ||
    configUploadDetails.status === "loading" ||
    getColumnsDetails.status === "loading" ||
    excelHeaderToDbColumnsDetails.status === "loading" ||
    isFetchingCompanies ||
    getDownloadFormat.status === "loading";

  const [company, setCompany] = useState("");
  // "" — no company chosen yet (select disabled); "all" — Associate Company set
  // to "All" (parent company's own branding); otherwise a specific AC's id.
  const [associate_company, setAssociateCompany] = useState("");
  const rawAssociateCompanies = company
    ? ((companies.find((c: any) => c.id === company) || {}).associate_companies || [])
    : [];
  const associateCompanies = company
    ? [ALL_AC_OPTION, ...rawAssociateCompanies]
    : [];
  const [configType, setConfigType] = useState<any>("");

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [uploadData, setUploadData] = useState<any>();
  const [uploadError, setUploadError] = useState(false);

  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  const [tableData, setTableData] = useState<any>([]);

  const [errorfilepath, setErrorFilePath] = useState<any>();

  const [showmappinglne, setShowMappingLine] = useState(false);

  const [showUploadMessage, setShowUploadMessage] = useState(false);

  const [enableUpdate, setEnableUpdate] = useState(false);
  const [openReuploadConfirmModal, setOpenReuploadConfirmModal] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const MAX_FILE_SIZE_MB = 25;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
  const ALLOWED_EXTENSIONS = ['.xls', '.xlsx'];

  const validateAndSetFile = (file: File | null | undefined) => {
    if (!file) return;
    const ext = '.' + (file.name.split('.').pop() || '').toLowerCase();
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
      toast.error('Invalid file format. Allowed formats: XLS, XLSX');
      return;
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast.error(`File size exceeds ${MAX_FILE_SIZE_MB}MB limit`);
      return;
    }
    setUploadData(file);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      validateAndSetFile(e.dataTransfer.files[0]);
    }
  };

  const isReuploadMode = tableData.length > 0 && enableUpdate;
  const hideUploadButton = tableData.length > 0 && !enableUpdate;

  // clra related — derive locations from userCompanies
  const selectedAssocCompany = associate_company
    ? (associateCompanies.find((ac: any) => ac.id === associate_company) || {})
    : {};
  const locations = (selectedAssocCompany && selectedAssocCompany.locations) || [];
  const companyEmployerSubContractorsDetails = useAppSelector(
    (state) => state.performerClient.companyEmployerSubContractorsDetails,
  );
  let companyEmployerSubContractors: any[] = [];
  if (
    companyEmployerSubContractorsDetails &&
    companyEmployerSubContractorsDetails.data &&
    companyEmployerSubContractorsDetails.data.items
  ) {
    const items = companyEmployerSubContractorsDetails.data.items || [];
    const tempEmployers: any[] = [];
    items.forEach((x: any) => {
      if (x.employer_id && x.employer) {
        if (!tempEmployers.some((y: any) => y.id === x.employer.id)) {
          tempEmployers.push(x.employer);
        }
      }
    });
    companyEmployerSubContractors = tempEmployers;
  } else {
    companyEmployerSubContractors = [];
  }
  const [establishmentType, setEstablishmentType] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [employer, setEmployer] = useState<string>("");

  const handleChangeEstablishmentType = (option: any) => {
    const newValue = option ? option.value : "";
    if (newValue === establishmentType) return;
    setConfigType("");
    setCompany("");
    setAssociateCompany("");
    // Don't null the branding here — the company list isn't filtered by
    // establishment type, so the auto-select effect below picks the same (or
    // next) company right after this and sets branding itself. Nulling it
    // first is what caused the ezyCOMP default logo to flash before the real
    // company logo re-appeared.
    resetDataValues();
    setEstablishmentType(newValue);
  };

  const handleChangeLocation = (option: any) => {
    const newValue = option ? option.value : "";
    if (newValue === location) return;
    setEmployer("");
    resetDataValues();
    setLocation(newValue);
  };

  const handleChangeEmployer = (option: any) => {
    const newValue = option ? option.value : "";
    if (newValue === employer) return;
    resetDataValues();
    setEmployer(newValue);
  };

  const handleChangeConfigType = (option: any) => {
    const newValue = option ? option.value : "";
    if (newValue === configType) return;
    setLocation("");
    setEmployer("");
    resetDataValues();
    setConfigType(newValue);
  };

  const handleChangeCompany = (option: any) => {
    const newValue = option ? option.value : "";
    if (newValue === company) return;
    setConfigType("");
    setLocation("");
    setEmployer("");
    resetDataValues();
    setCompany(newValue);
    if (newValue) {
      // Associate Company resets to "All" whenever the company changes, showing
      // the parent company's own branding, rather than auto-selecting a specific AC.
      setAssociateCompany("all");
      const _company = companies.find((c: any) => c.id === newValue);
      setAssociateCompanyBranding(_company);
    } else {
      setAssociateCompany("");
      setAssociateCompanyBranding(null);
    }
  };

  const handleChangeAssociateCompany = (option: any) => {
    const newValue = option ? option.value : "all";
    if (newValue === associate_company) return;
    setConfigType("");
    setLocation("");
    setEmployer("");
    resetDataValues();
    setAssociateCompany(newValue);
    if (newValue === "all") {
      // "All" shows the parent company's own branding.
      const _company = companies.find((c: any) => c.id === company);
      setAssociateCompanyBranding(_company);
    } else {
      setAssociateCompanyBranding(option);
    }
  };

  // Once Establishment Type is chosen, auto-select the first Company
  // alphabetically — matches the Compliance Dashboard's cascade. Associate
  // Company does NOT auto-select a specific AC any more: handleChangeCompany
  // resets it to "All" (parent company's own branding), and the user picks a
  // specific one manually from there.
  // Only resolve the logo to "nothing selectable" once a fetch has genuinely
  // finished and found zero companies — never just because nothing's picked
  // yet, or the default ezyCOMP logo flashes before the real one loads.
  useEffect(() => {
    if (!establishmentType || company || isFetchingCompanies) return;
    if (companies.length === 0) {
      setAssociateCompanyBranding(null);
      return;
    }
    const sorted = [...companies].sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
    handleChangeCompany({ value: sorted[0].id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [establishmentType, companies, isFetchingCompanies]);

  const handleChangeEzycompField = (event: any, fieldData: any) => {
    const newTableData = tableData.map((each: any) => {
      if (each.id === fieldData.id) {
        return { ...each, employee_field_name: event.value, mapped: true };
      } else {
        return each;
      }
    });
    setTableData(newTableData);
  };

  useEffect(() => {
    setUploadError(false);
    resetStateValues();
  }, []);

  // Auto-select the first Establishment Type option on landing — matches
  // PerformerBaseFilters's own dropdown order (Shops, CLRA, Factory), not
  // alphabetical.
  useEffect(() => {
    if (establishmentType) return;
    const first = Object.values(ESTABLISHMENT_TYPE)[0];
    if (first) handleChangeEstablishmentType({ value: first, label: first });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Then auto-select the first Company alphabetically, once Establishment
  // Type is set and the companies list has resolved — mirrors
  // PerformerBaseFilters's own alphabetical sort so "first" agrees with what
  // the dropdown shows on top.
  useEffect(() => {
    if (!establishmentType || company || isFetchingCompanies) return;
    if (!companies || companies.length === 0) return;
    const sorted = [...companies].sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""));
    handleChangeCompany({ value: sorted[0].id, label: sorted[0].name });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [establishmentType, companies, isFetchingCompanies, company]);

  useEffect(() => {
    if (configType) {
      const payload: any = {
        search: "",
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company,
          establishment_type_eq: establishmentType,
          is_assoc_cmp_config_eq: !employer ? true : false,
        },
        per: 200,
        page: 1,
        sorts: ["company_id asc"],
        includeCentral: true,
      };
      payload.filters["location_id_null"] = true;
      payload.filters["employer_id_null"] = true;
      dispatch(getInputModuleMappingDetails(payload));
    } else if (!associate_company) {
      resetDataValues();
    }
  }, [associate_company]);

  useEffect(() => {
    if (configType) {
      const payload: any = {
        search: "",
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company,
          establishment_type_eq: establishmentType,
          is_assoc_cmp_config_eq: !employer ? true : false,
        },
        per: 200,
        page: 1,
        sorts: ["company_id asc"],
        includeCentral: true,
      };
      payload.filters["location_id_null"] = true;
      payload.filters["employer_id_null"] = true;
      dispatch(getInputModuleMappingDetails(payload));
    } else {
      resetDataValues();
    }
  }, [configType]);

  useEffect(() => {
    const payloadForEmployer: any = {
      filters: {
        is_parent_eq: true,
        associate_company_id_eq: associate_company,
      },
      per: 5000,
      page: 1,
      sorts: ["name asc"],
      includeCentral: true,
      include: {
        employer: {
          only: ["id", "name"],
        },
        sub_contractor: {
          only: ["name"],
        },
        employer_location: {
          only: ["location_name"],
        },
        sub_contractor_location: {
          only: ["location_name"],
        },
      },
    };
    if (location) {
      const payloadForMappingDetails: any = {
        search: "",
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company,
          establishment_type_eq: establishmentType,
          is_assoc_cmp_config_eq: !employer ? true : false,
        },
        per: 200,
        page: 1,
        sorts: ["company_id asc"],
        includeCentral: true,
      };
      if (location) {
        payloadForMappingDetails.filters["location_id_eq"] = location;
      }
      payloadForMappingDetails.filters["employer_id_null"] = true;
      dispatch(getInputModuleMappingDetails(payloadForMappingDetails));
      const selectedLoc = locations.find((each: any) => each.location_id === location) || {};
      payloadForEmployer.filters["company_location_mapping_id_eq"] =
        selectedLoc.company_location_mapping_id || selectedLoc.id;
      dispatch(getCompanyEmployerSubContractors(payloadForEmployer));
    } else {
      resetDataValues();
    }
  }, [location]);

  useEffect(() => {
    if (employer) {
      const payload: any = {
        search: "",
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company,
          establishment_type_eq: establishmentType,
          is_assoc_cmp_config_eq: !employer ? true : false,
        },
        per: 200,
        page: 1,
        sorts: ["company_id asc"],
        includeCentral: true,
      };
      if (location) {
        payload.filters["location_id_eq"] = location;
      }
      if (employer) {
        payload.filters["employer_id_eq"] = employer;
      }
      dispatch(getInputModuleMappingDetails(payload));
    }
  }, [employer]);

  useEffect(() => {
    if (employeeUploadDetails.status === "succeeded") {
      const contentType =
        (employeeUploadDetails.data &&
          employeeUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
        toast.success(
          employeeUploadDetails.data.statusMessage || "Upload Successfully",
        );
      } else {
        setErrorFilePath(employeeUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (employeeUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [employeeUploadDetails.status]);

  useEffect(() => {
    if (employeeAttendanceUploadDetails.status === "succeeded") {
      const contentType =
        (employeeAttendanceUploadDetails.data &&
          employeeAttendanceUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
        toast.success(
          employeeAttendanceUploadDetails.data.statusMessage ||
            "Upload Successfully",
        );
      } else {
        setErrorFilePath(employeeAttendanceUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (employeeAttendanceUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeAttendanceUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [employeeAttendanceUploadDetails.status]);

  useEffect(() => {
    if (employeeLeaveCreditUploadDetails.status === "succeeded") {
      const contentType =
        (employeeLeaveCreditUploadDetails.data &&
          employeeLeaveCreditUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
        toast.success(
          employeeLeaveCreditUploadDetails.data.statusMessage ||
            "Upload Successfully",
        );
      } else {
        setErrorFilePath(employeeLeaveCreditUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (employeeLeaveCreditUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeLeaveCreditUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [employeeLeaveCreditUploadDetails.status]);

  useEffect(() => {
    if (employeeLeaveAvailedUploadDetails.status === "succeeded") {
      const contentType =
        (employeeLeaveAvailedUploadDetails.data &&
          employeeLeaveAvailedUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
        toast.success(
          employeeLeaveAvailedUploadDetails.data.statusMessage ||
            "Upload Successfully",
        );
      } else {
        setErrorFilePath(employeeLeaveAvailedUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (employeeLeaveAvailedUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeLeaveAvailedUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [employeeLeaveAvailedUploadDetails.status]);

  useEffect(() => {
    if (employeeWageUploadDetails.status === "succeeded") {
      const contentType =
        (employeeWageUploadDetails.data &&
          employeeWageUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
        toast.success(
          employeeWageUploadDetails.data.statusMessage || "Upload Successfully",
        );
      } else {
        setErrorFilePath(employeeWageUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (employeeWageUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [employeeWageUploadDetails.status]);

  useEffect(() => {
    if (configUploadDetails.status === "succeeded") {
      const contentType =
        (configUploadDetails.data &&
          configUploadDetails.data.headers["content-type"]) ||
        "";
      if (contentType.includes("application/json")) {
        const payload: any = {
          search: "",
          filters: {
            configuration_type_eq: configType,
            company_id_eq: company,
            associate_company_id_eq: associate_company,
            establishment_type_eq: establishmentType,
            is_assoc_cmp_config_eq: !employer ? true : false,
          },
          per: 200,
          page: 1,
          sorts: ["company_id asc"],
          includeCentral: true,
        };
        if (location) {
          payload.filters["location_id_eq"] = location;
        } else {
          payload.filters["location_id_null"] = true;
        }
        if (employer) {
          payload.filters["employer_id_eq"] = employer;
        } else {
          payload.filters["employer_id_null"] = true;
        }
        dispatch(getInputModuleMappingDetails(payload));
        resetUploadDetails();
        setOpenUploadModal(false);
        setUploadData(null);
      } else {
        setErrorFilePath(configUploadDetails.data);
        setUploadError(true);
        setUploadData(null);
      }
    } else if (configUploadDetails.data.file_path != null) {
      setUploadError(true);
      setUploadData(null);
    } else if (configUploadDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetEmployeeUploadDetails());
      dispatch(resetConfigUploadDetails());
      setUploadData(null);
    }
  }, [configUploadDetails.status]);

  useEffect(() => {
    if (excelHeaderToDbColumnsDetails.status === "succeeded") {
      toast.success("Mappings Updated Successfully");
      // toast.info("Upload the Data Now");
      const payload: any = {
        search: "",
        filters: {
          configuration_type_eq: configType,
          company_id_eq: company,
          associate_company_id_eq: associate_company,
          establishment_type_eq: establishmentType,
          is_assoc_cmp_config_eq: !employer ? true : false,
        },
        per: 200,
        page: 1,
        sorts: ["company_id asc"],
        includeCentral: true,
      };
      if (location) {
        payload.filters["location_id_eq"] = location;
      } else {
        payload.filters["location_id_null"] = true;
      }
      if (employer) {
        payload.filters["employer_id_eq"] = employer;
      } else {
        payload.filters["employer_id_null"] = true;
      }
      dispatch(getInputModuleMappingDetails(payload));
    } else if (excelHeaderToDbColumnsDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  }, [excelHeaderToDbColumnsDetails.status]);

  useEffect(() => {
    if (getDownloadFormat.status === "succeeded") {
      toast.success("Format downloaded successfully");
      dispatch(resetDownloadFormat());
    } else if (getDownloadFormat.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      dispatch(resetDownloadFormat());
    }
  }, [getDownloadFormat.status]);

  const getBackendConfigType = (type: string) => {
    let backend_type = "";
    switch (type) {
      case "Employee":
        backend_type = "employee";
        break;
      case "Employee Attendance":
        backend_type = "employee_attendance";
        break;
      case "Leave Credit":
        backend_type = "employee_leave_credit";
        break;
      case "Leave Availed":
        backend_type = "employee_leave_availed";
        break;
      case "Employee Wage":
        backend_type = "employee_wage";
        break;
    }
    return backend_type;
  };

  useEffect(() => {
    if (!configType || !company || !associate_company) return;
    if (configMappingDetails.status === "succeeded") {
      if (configMappingList && configMappingList.length > 0) {
        const mappedArray: any[] = configMappingList.map(
          (each: any) => each.mapped,
        );
        if (mappedArray.every((val) => val)) {
          setEnableUpdate(false);
        } else {
          setShowMappingLine(true);
          setEnableUpdate(true);
        }
        setTableData(configMappingList);
        const backend_type = getBackendConfigType(configType);
        dispatch(getColumns(backend_type));
      } else {
        setTableData([]);
        setShowUploadMessage(true);
      }
    } else if (configMappingDetails.status === "failed") {
      toast.error(ERROR_MESSAGES.DEFAULT);
      resetGetConfigMappingDetails();
    }
  }, [configMappingDetails.status]);

  const configurationTypes = [
    "Employee",
    "Leave Credit",
    "Leave Availed",
    "Employee Attendance",
    "Employee Wage",
  ];

  const onClickUpload = () => {
    if (!company || !associate_company || associate_company === "all" || !configType) {
      return toast.error(ERROR_MESSAGES.FILL_ALL);
    } else {
      setOpenUploadModal(true);
    }
  };

  const onClickSubmitUpload = () => {
    const formData = new FormData();
    const data = uploadData || null;
    formData.append("file", data);
    formData.append("remarks", "NA");
    formData.append("mapped", "false");
    formData.append("configuration_type", configType);
    formData.append("company_id", company);
    formData.append("associate_company_id", associate_company);
    formData.append("establishment_type", establishmentType);
    const is_assoc_cmp_config_eq = !employer ? true : false;
    formData.append("is_assoc_cmp_config", is_assoc_cmp_config_eq.toString());
    if (location) {
      formData.append("location_id", location);
    }
    if (employer) {
      formData.append("employer_id", employer);
    }
    dispatch(configUpload(formData));
  };

  const onClickSave = () => {
    const check = tableData.find(
      (each: any) =>
        each.employeeFieldName === null || each.employeeFieldName === "",
    );
    if (check) {
      return toast.error("Please Select All Ezycomp Fields");
    } else {
      dispatch(
        callExcelHeaderToDbColumns({
          list_excel_header_to_db_columns_map: tableData,
        }),
      );
      setShowMappingLine(false);
    }
  };

  const downloadErrors = (e: any) => {
    preventDefault(e);
    const data = errorfilepath.data;
    const blob = new Blob([data], {
      type: errorfilepath.headers["content-type"],
    });
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);
    download("Errors.xlsx", downloadUrl);
  };


  const resetUploadDetails = () => {
    dispatch(resetConfigUploadDetails());
    dispatch(resetEmployeeUploadDetails());
    dispatch(resetEmployeeAttendanceUploadDetails());
    dispatch(resetEmployeeLeaveCreditUploadDetails());
    dispatch(resetEmployeeLeaveAvailedUploadDetails());
    dispatch(resetEmployeeWageUploadDetails());
    setUploadError(false);
  };

  const handleDownloadSampleFormat = async () => {
    if (!configType) return toast.error("Please select a configuration type");
    const s3Key = SAMPLE_FORMAT_S3_KEY_MAPPING[establishmentType] && SAMPLE_FORMAT_S3_KEY_MAPPING[establishmentType][configType];
    if (!s3Key) return toast.error("Sample format not available for this configuration type");
    try {
      const s3Bucket = process.env.REACT_APP_S3_BUCKET || "mafoi-internal";
      const inputModuleService = new InputModuleService();
      await inputModuleService.emailSampleFormat({
        s3_key: s3Key,                                                                                                                                                                                      
        s3_bucket: s3Bucket,                                                                                                                                                                                
        configuration_type: configType,
        establishment_type: establishmentType,                                                                                                                                                                     
      });                                                                                                                                                                                                   
      toast.success('The template will be sent on your registered email.');                                                                                                                                          
    } catch (e) {                                                 
      toast.error('Failed to send sample format. Please try again.');                                                                                                                                       
    }
  };

  const resetStateValues = () => {
    dispatch(resetConfigUploadDetails());
    dispatch(resetGetColumnsDetails());
    dispatch(resetExcelHeaderToDbColumnsDetails());
    dispatch(resetEmployeeUploadDetails());
    dispatch(resetEmployeeAttendanceUploadDetails());
    dispatch(resetEmployeeLeaveCreditUploadDetails());
    dispatch(resetEmployeeLeaveAvailedUploadDetails());
    dispatch(resetEmployeeWageUploadDetails());
    dispatch(resetGetConfigMappingDetails());

    setOpenUploadModal(false);
    setOpenPreviewModal(false);
    setConfigType("");
    setCompany("");
    setAssociateCompany("");
    setEstablishmentType("");
    setLocation("");
    setEmployer("");
    setUploadData(null);
    setTableData([]);
    setShowUploadMessage(false);
    setEnableUpdate(false);
    setShowMappingLine(false);
  };

  const resetDataValues = () => {
    dispatch(resetConfigUploadDetails());
    dispatch(resetExcelHeaderToDbColumnsDetails());
    dispatch(resetEmployeeUploadDetails());
    setUploadData(null);
    setTableData([]);
  };

  return (
    <>
    <div className="performerclient-wrapper h-100">
      <div className="performer-client-page h-100 py-3">
      {/* Upload Modal */}
      <Modal
        open={openUploadModal}
        onClose={() => { setOpenUploadModal(false); setUploadError(false); setUploadData(null); }}
      >
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 660, borderRadius: '8px', outline: 'none', backgroundColor: '#FFFFFF', fontFamily: 'Montserrat !important' }}>
          {/* Header */}
          <Box sx={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontFamily: 'Montserrat !important' }}>
            <Box>
              <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#1E1E1E', lineHeight: '28px', fontFamily: 'Montserrat !important' }}>
                Upload Field Mapping
              </Typography>
              <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#757575', lineHeight: '18px', fontFamily: 'Montserrat !important', paddingTop: '4px' }}>Download the sample format file, update the data and upload the file here.
              </Typography>
            </Box>
            <IconButton onClick={() => { setOpenUploadModal(false); setUploadError(false); setUploadData(null); }} sx={{ fontSize: '20px', padding: "0px"  }}>
              <IoMdClose />
            </IconButton>
          </Box>

          <hr style={{margin: "0px 16px"}} />

          {/* Body */}
          <Box sx={{ padding: '16px' }}>
            {uploadError && (
              <Alert variant="danger" className="mb-3">
                There are few errors identified in the file uploaded. Correct the errors and upload again.{" "}
                <a href="/" onClick={downloadErrors}>Click here</a> to download the errors.
              </Alert>
            )}

            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#1E1E1E', marginBottom: '8px', fontFamily: 'Montserrat !important' }}>
              Upload files
            </Typography>

            {/* Hidden file input */}
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  validateAndSetFile(e.target.files[0]);
                }
                e.target.value = '';
              }}
              style={{ display: 'none' }}
            />

            {/* Upload box — shown when no file selected (removed isReuploadMode trigger) */}
            {!uploadData && (
              <div
                className="performer-upload-box p-4 text-center"
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                onDragOver={handleDragOver}
                onDragEnter={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="mb-2">
                  <img src={cloudUpload} alt="upload" />
                </div>
                <p className="mb-2" style={{ color: '#757575', fontSize: '14px', fontFamily: 'Montserrat !important' }}>
                  Drag and drop files here or click to browse
                </p>
                <button
                  type="button"
                  className="performer-choose-file-btn mb-2"
                  onClick={(e) => { e.stopPropagation(); fileInputRef.current && fileInputRef.current.click(); }}
                >
                  Choose File
                </button>
                <div>
                  <small style={{ color: '#b2b2b2', fontSize: '12px' }}>
                    Supported formats(Upto 25 Mb): XLS, XLSX
                  </small>
                </div>
              </div>
            )}

            {/* File selected — shown when file is selected */}
            {uploadData && (
              <div className="performer-upload-successful position-relative">
                <div
                  className="performer-upload-close position-absolute"
                  onClick={() => setUploadData(null)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M10.0002 5.99992L6.00016 9.99992M6.00016 5.99992L10.0002 9.99992M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z"
                      stroke="#757575"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="p-3 d-flex align-items-center">
                  <p className="m-0" style={{ fontSize: '14px', color: '#1E1E1E', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '90%' }}>
                    {uploadData.name}
                  </p>
                </div>
              </div>
            )}

            {/* Download Sample Format */}
            {configType && SAMPLE_FORMAT_S3_KEY_MAPPING[establishmentType] && SAMPLE_FORMAT_S3_KEY_MAPPING[establishmentType][configType] && (
              <div style={{ marginTop: '9px' }}>
                <a
                  onClick={(e) => { preventDefault(e); handleDownloadSampleFormat(); }}
                  style={{ fontSize: '12px', fontWeight: "500", color: '#2965AD', display: 'inline-flex', alignItems: 'center', gap: '6px', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2.66669 11.3333V12.6666C2.66669 13.0202 2.80716 13.3594 3.05721 13.6094C3.30726 13.8595 3.64640 14 4.00002 14H12C12.3536 14 12.6928 13.8595 12.9428 13.6094C13.1929 13.3594 13.3334 13.0202 13.3334 12.6666V11.3333M10.6667 8L8.00002 10.6666M8.00002 10.6666L5.33335 8M8.00002 10.6666V2.66663" stroke="#2965AD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span style={{
                    textDecoration: "underline",
                    textUnderlineOffset: "2px"
                  }}>Download Sample Format</span>                  
                </a>
              </div>
            )}
          </Box>

          <hr style={{margin: "0px 16px"}} />

          {/* Footer */}
          <Box sx={{ padding: '16px', display: 'flex', gap: '24px' }}>
            <button
              className="button-secondary w-50"
              onClick={() => { setOpenUploadModal(false); setUploadError(false); setUploadData(null); }}
            >
              Cancel
            </button>
            <button
              className="button-primary w-50"
              disabled={!uploadData}
              onClick={() => isReuploadMode ? setOpenReuploadConfirmModal(true) : onClickSubmitUpload()}
            >
              Upload
            </button>
          </Box>
        </Box>
      </Modal>

      {/* Reupload Confirmation Modal */}
      <Modal
        open={openReuploadConfirmModal}
        onClose={() => { setOpenReuploadConfirmModal(false); setUploadData(null); }}
      >
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 480, borderRadius: '8px', outline: 'none', backgroundColor: '#FFFFFF', fontFamily: 'Montserrat !important' }}>
          <Box sx={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 700, color: '#1E1E1E', lineHeight: '20px', fontFamily: 'Montserrat !important' }}>
              Re-upload field mapping
            </Typography>
            <IconButton onClick={() => { setOpenReuploadConfirmModal(false); setUploadData(null); }} sx={{ fontSize: '16px', padding: '0px' }}>
              <IoMdClose />
            </IconButton>
          </Box>
          <hr style={{margin: "0px 16px"}}/>
          <Box sx={{ padding: '16px' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#1E1E1E', fontFamily: 'Montserrat !important' }}>
              Are you sure you want to re-upload the field mapping? Previous field mapping will be replaced.
            </Typography>
          </Box>
          <hr style={{margin: "0px 16px"}}/>
          <Box sx={{ padding: '16px', display: 'flex', gap: '24px' }}>
            <button
              className="button-secondary w-50"
              onClick={() => { setOpenReuploadConfirmModal(false); setUploadData(null); }}
            >
              Cancel
            </button>
            <button
              className="button-primary w-50"
              onClick={() => { setOpenReuploadConfirmModal(false); setOpenUploadModal(false); onClickSubmitUpload(); }}
            >
              Re-upload
            </button>
          </Box>
        </Box>
      </Modal>

        <div className="h-100">
          {/* Page Heading */}
          <div className="pageHeading mb-0">
            <h4 className="mb-0">Field Mapping</h4>
            {/* <p>Select and map your company&apos;s fields to the corresponding EzyComp fields to ensure accurate data transfer.</p> */}
          </div>

          {/* Filter Box*/}
          <div className="filters" style={{ padding: "16px 20px" }}>
            <div style={{ backgroundColor: "#ffffff", padding: "16px 16px", borderRadius: "8px" }}>
              <div className="filter-container">
                <PerformerBaseFilters
                  establishmentType={establishmentType}
                  company={company}
                  associateCompany={associate_company}
                  companies={companies}
                  associateCompanies={associateCompanies}
                  onEstablishmentTypeChange={handleChangeEstablishmentType}
                  onCompanyChange={handleChangeCompany}
                  onAssociateCompanyChange={handleChangeAssociateCompany}
                />

                <div>
                  <label className="filter-label"><small>Configuration Type</small></label>
                  <Select
                    placeholder="Select Configuration Type"
                    options={configurationTypes.map((each: any) => ({ value: each, label: each }))}
                    value={configType ? { value: configType, label: configType } : null}
                    onChange={handleChangeConfigType}
                    isDisabled={!associate_company || associate_company === "all"}
                    className="select-control"
                    components={{ DropdownIndicator: PerformerDropdownIndicator }}
                  />
                </div>

                {establishmentType === "CLRA" && (
                  <>
                    <div>
                      <label className="filter-label"><small>Location (Optional)</small></label>
                      <Select
                        placeholder="Select Location"
                        options={locations
                          .filter((each: any) => each.location_id && each.state)
                          .slice()
                          .sort((a: any, b: any) => {
                            const stateA = (a.state && a.state.name) || "";
                            const stateB = (b.state && b.state.name) || "";
                            const stateCmp = stateA.localeCompare(stateB);
                            if (stateCmp !== 0) return stateCmp;
                            return (a.name || "").localeCompare(b.name || "");
                          })
                          .map((each: any) => {
                            const { name, code, city, state } = each;
                            return { value: each.location_id, label: `${name} (${(state || {}).code}-${(city || {}).code}-${code})` };
                          })}
                        value={location ? { value: location, label: (() => { const loc = locations.find((l: any) => l.location_id === location); if (!loc) return ""; const { name, code, city, state } = loc; return `${name} (${(state || {}).code}-${(city || {}).code}-${code})`; })() } : null}
                        onChange={handleChangeLocation}
                        isDisabled={!associate_company || associate_company === "all"}
                        className="select-control"
                        components={{ DropdownIndicator: PerformerDropdownIndicator }}
                      />
                    </div>
                    <div>
                      <label className="filter-label"><small>Employer (Optional)</small></label>
                      <Select
                        placeholder="Select Employer"
                        options={companyEmployerSubContractors.map((each: any) => ({ value: each.id, label: each.name }))}
                        value={employer ? { value: employer, label: (companyEmployerSubContractors.find((e: any) => e.id === employer) || {}).name || "" } : null}
                        onChange={handleChangeEmployer}
                        isDisabled={!location}
                        className="select-control"
                        components={{ DropdownIndicator: PerformerDropdownIndicator }}
                      />
                    </div>
                  </>
                )}

                <div className="d-flex align-items-end" style={{maxWidth: "min-content"}}>
                  {hasUserAccess(
                    USER_PRIVILEGES.UPLOAD_PERFORMER_CLIENT_DATA,
                  ) && !hideUploadButton && (
                    <button
                      className="button-primary"
                      onClick={onClickUpload}
                      style={{height: "min-content", width: "max-content" }}
                    >
                      {isReuploadMode ? "Re-upload" : "Upload"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {configType &&
            company &&
            associate_company &&
            associate_company !== "all" &&
            tableData &&
            tableData.length > 0 && (
              <div className="fieldmapping-table" style={{ padding: "0 20px" }}>
                <PerformerTable
                  columns={[
                    { label: "Sr. no", render: (_, i) => i },
                    { label: "Column Name", render: (row) => row.excel_column_header_name },
                    { label: "Column Position", render: (row) => row.column_position },
                    { label: "Row Position", render: (row) => row.row_position },
                    {
                      label: "Ezycomp Field", render: (row) => (
                        <Select
                          options={columnsList ? columnsList.map((c: any) => ({ label: c.field_name, value: c.field_name })) : []}
                          className="basic-multi-select w-100"
                          classNamePrefix="select"
                          value={row.employee_field_name ? { label: row.employee_field_name, value: row.employee_field_name } : null}
                          styles={customStyles}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuShouldScrollIntoView={false}
                          onChange={(e) => handleChangeEzycompField(e, row)}
                          isDisabled={configMappingList && (configMappingList.find((item: any) => item.id === row.id) || {}).mapped}
                          components={{ Option: CustomOption }}
                          onMenuOpen={() => {
                            if (row.employee_field_name) {
                              setTimeout(() => {
                                const menuList = document.querySelector('.select__menu-list');
                                const selectedEl = menuList && menuList.querySelector('.select__option--is-selected');
                                if (menuList && selectedEl) {
                                  menuList.scrollTop = (selectedEl as HTMLElement).offsetTop - menuList.clientHeight / 2;
                                }
                              }, 0);
                            }
                          }}
                        />
                      )
                    },
                    { label: "Mapped", render: (row) => row.mapped ? "Yes" : "No" },
                  ]}
                  data={tableData || []}
                  count={(tableData || []).length}
                  page={0}
                  rowsPerPage={(tableData || []).length}
                  activeSort=""
                  sortType="asc"
                  onSort={() => {}}
                  onPageChange={() => {}}
                  onRowsPerPageChange={() => {}}
                  hidePagination={true}
                />
                {enableUpdate && (
                  <div className="w-100 position-absolute" style={{ bottom: "20px", right: "30px", display: "flex", justifyContent: "flex-end" }}>
                    <button
                      className="button-primary me-2"
                      onClick={onClickSave}
                      style={{ width: "150px" }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            )}
          {(!configType ||
            !company ||
            !associate_company ||
            associate_company === "all" ||
            (tableData && tableData.length == 0)) && (
            <div
              style={{
                height: "80%",
                display: "flex",
                backgroundColor: "#ffffff",
                margin: "0px 20px",
              }}
            >
              <div className="d-flex flex-column p-4">
                <div
                  className="text-lg fw-bold mb-4"
                  style={{ fontSize: "18px", fontWeight: "700px" }}
                >
                  Instructions
                </div>
                <ul className="d-flex flex-column" style={{ fontSize: "14px", fontWeight: "500", paddingLeft: "20px", gap: "8px" }}>
                  <li>
                    To upload data, we need to configure the templates for each
                    type (Employee, Leave Credit, Leave Availed, Attendance,
                    Wage).
                  </li>
                  <li>
                    Select Establishment Type, Company, Associate Company, and
                    Configuration Type to proceed.
                  </li>
                  <li>
                    If Establishment Type is CLRA, you can optionally select
                    Location and Employer.
                  </li>
                  <li>
                    After selecting the above details, click on the 'Upload'
                    button to upload the configuration template.
                  </li>
                  <li>Once a template is configured, it cannot be edited.</li>
                  <li>
                    Sample templates or actual templates can be downloaded from
                    upload and preview modal respectively.
                  </li>
                  <li>Templates for Shops and CLRA are different.</li>
                  <li>
                    Templates can be configured at the Associate Company level
                    for Shops.
                  </li>
                  <li>
                    For CLRA, templates can be configured at the Associate
                    Company level, Location level, or Employer level.
                  </li>
                  <li>
                    Column instructions are included in the template
                    (Instructions sheet).
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    {loading && <PageLoader>Loading...</PageLoader>}
    </>
  );
};

export default FieldMapping;
